$.fn.SearchBar = function() {
  let self = this

  // Update CSS variable for recent products height
  function updateRecentProductsHeight() {
    const recentProductsHeight = $('.search-bar__recent-products').outerHeight() || 0
    $('html').css('--recent-products-height', recentProductsHeight + 'px')
  }

  // Call on init and when window resizes
  updateRecentProductsHeight()
  $(window).on('resize', updateRecentProductsHeight)

  $('.js-show-search-bar').click(function() {
    $('body').addClass('--search-open')
    setTimeout(function() {
      self.find('.search-bar__input').focus().select();
    }, 10);
    return false;
  })

  self.find('.search-bar__close').click(function() {
    $('body').removeClass('--search-open')
  })

  self.next('.search-bar__overlay').click(function() {
    $('body').removeClass('--search-open')
  })

  $('.search-bar__wrapper .search-bar__input').QuickSearch()

  // Make updateRecentProductsHeight accessible
  self.updateRecentProductsHeight = updateRecentProductsHeight

  return this.each(function() {

  })
}

/* Quick search plugin */
$.fn.QuickSearch = function(options) {
  const settings = $.extend({
    minChars: 3,
    debounce: 300,
    carouselSelector: '.search-bar__results',
    apiUrl: '/_api/search.php'
  }, options)
  return this.each(function() {
    const $input = $(this)
    const $carousel = $(settings.carouselSelector)
    const $wrapper = $carousel.find('.grid')
    const lang = document.documentElement.lang || 'fr'
    let timeoutId
    $input.on('input', () => {
      // if ($.mlmi.mobile.isMobile) {
      //   return
      // }
      const query = $input.val().trim()
      clearTimeout(timeoutId)
      if (query.length < settings.minChars) {
        $carousel.addClass('d-none')
        return
      }
      timeoutId = setTimeout(() => {
        $.get(settings.apiUrl, { s: query, lang })
        .done(data => {
          const $data = $('<div>').html(data)
          const $cards = $data.find('article')
          $wrapper.find('.grid__item').remove()
          if (!$cards.length) {
            $carousel.addClass('d-none')
            return
          }
          $carousel.removeClass('d-none')
          $cards.each(function() {
            const $card = $(this).removeClass('fade-in')
            //$.mlmi.favorites.buttons($card)
            //$card.find('.ajax_add_to_cart').CartButton()
            const $slide = $('<div>').addClass('grid__item').append($card)
            $wrapper.append($slide)
          })
        })
      }, settings.debounce)
    })
  })
}
